import * as XLSX from 'xlsx';
import { DailyWorkResponse, WorkType } from '../models/daily-work';
import { UserRole } from '../models/user';
import { formatLocale } from '../providers/dayjs-plugins';
import {
  dailyWorkJustificationHumanized,
  dailyWorkTypeHumanized,
  getFaultLabel,
} from './constants/daily-work';
import { userRoleHumanized } from './constants/user';

export function exportDailyWorkToExcel(
  data: DailyWorkResponse[],
  fileName = 'horarios',
) {
  const rows = data.map((item) => {
    const tipo =
      item.type === WorkType.FAULT
        ? getFaultLabel(item.role)
        : dailyWorkTypeHumanized[item.type] ?? item.type;

    const tipoUsuario = item.role
      ? userRoleHumanized[item.role as UserRole] ?? item.role
      : '';

    return {
      Tipo: tipo,
      Funcionário: item.username ?? '',
      'Tipo de Usuário': tipoUsuario,
      Código: item.access_code ?? '',
      Entrada: item.begin
        ? formatLocale(item.begin, 'DD/MM/YYYY HH:mm:ss')
        : '',
      'Início Intervalo': item.start_lounch
        ? formatLocale(item.start_lounch, 'DD/MM/YYYY HH:mm:ss')
        : '',
      'Fim Intervalo': item.end_lounch
        ? formatLocale(item.end_lounch, 'DD/MM/YYYY HH:mm:ss')
        : '',
      Saída: item.finish
        ? formatLocale(item.finish, 'DD/MM/YYYY HH:mm:ss')
        : '',
      'Horas Trabalhadas':
        item.type === WorkType.WORK ? item.workHours ?? '' : '',
      'Valor da Diária': item.type === WorkType.WORK ? item.price ?? '' : '',
      'Valor a Receber':
        item.type === WorkType.WORK ? item.totalValue ?? '' : '',
      Escala:
        item.type === WorkType.WORK ? (item.isBankHour ? 'Sim' : 'Não') : '',
      Justificativa: item.justification
        ? dailyWorkJustificationHumanized[item.justification] ??
          item.justification
        : '',
      Descrição: item.description ?? '',
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(rows);

  const colWidths = [
    { wch: 22 }, // Tipo
    { wch: 30 }, // Funcionário
    { wch: 16 }, // Tipo de Usuário
    { wch: 12 }, // Código
    { wch: 22 }, // Entrada
    { wch: 22 }, // Início Intervalo
    { wch: 22 }, // Fim Intervalo
    { wch: 22 }, // Saída
    { wch: 18 }, // Horas Trabalhadas
    { wch: 16 }, // Valor da Diária
    { wch: 16 }, // Valor a Receber
    { wch: 10 }, // Escala
    { wch: 28 }, // Justificativa
    { wch: 30 }, // Descrição
  ];
  worksheet['!cols'] = colWidths;

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Horários');

  const timestamp = new Date().toLocaleDateString('pt-BR').replace(/\//g, '-');
  XLSX.writeFile(workbook, `${fileName}-${timestamp}.xlsx`);
}
